module.exports = __webpack_public_path__ + "static/PPT-16452afb8e4b94458edd454f2ba0545d.svg";